<div mat-dialog-content class="share-dialog">
  <div class="copy-button">
    <a (click)="copyUrl()">Click To Copy URL</a>
  </div>
  <canvas class="qrcode-canvas" #qrCodeCanvas></canvas>
</div>
